<template>
  <div
    class="container bg-upload"
    :class="{'nodashed':file.path !== ''}"
    ref="container"
  >
    <el-upload
      v-if="file.path === ''"
      :action="uploadSrc"
      name="img"
      class="bg-upload m-upload"
      :show-file-list="false"
      :data="uploadData"
      :on-success="uploadSuccess"
      :on-error="uploadFail"
      :before-upload="beforeUpload"
    >
      <i class="h-icon-add icon"></i>
    </el-upload>
    <div
      class="m-img-show-outer"
      v-else
    >
      <div
        class="img-show"
        :style="showStyle"
      >
        <div class="operator-wrapper">
          <div
            class="buttons"
            :class="{'has-no-del':!disableDel}"
          >
            <i
              v-if="disableDel"
              class="btn h-icon-delete"
              @click="removeImage"
            ></i>
            <el-upload
              :action="uploadSrc"
              class="bg-upload-replace"
              name="img"
              :data="uploadData"
              :on-success="uploadSuccess"
              :on-error="uploadFail"
              :before-upload="beforeUpload"
            >
              <i class="btn h-icon-update"></i>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configuration from 'api/config'
import API from 'api/api'
import { LoadingMixin } from 'utils/mixin'
export default {
  name: 'bg-upload',
  model: {
    prop: 'file',
    event: 'change'
  },
  props: {
    type: String,
    file: {
      type: Object,
      default () {
        return {
          fileId: -1,
          path: '',
          width: '',
          height: ''
        }
      }
    },
    disableDel: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  computed: {
    uploadSrc () {
      return `${configuration.baseUrl}${configuration.uploadSrc}`
    },
    uploadData () {
      return {
        usageScenario: this.type
      }
    },
    showStyle () {
      let _res = {
        'background-image': `url(${this.file.path})`
      }
      let _width = this.file.width ? parseInt(this.file.width) : 0
      if (_width > 0 && _width < 15) {
        _res['background-repeat'] = 'repeat-x'
      }
      return _res
    }
  },
  data () {
    return {
      loadingInstance: null
    }
  },
  methods: {
    beforeUpload (file) {
      if (!/.(png|jpg|JPG|PNG)$/.test(file.name)) {
        this.$message.error(this.$t('common.image_type_error'))
        return false
      }
      this.loadingInstance = this._getLoading()
      API.common.keepAlive()
      return true
    },
    uploadSuccess (response, file) {
      this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.upload_success'))
        this.$emit('change', {
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        })
      } else {
        this.$message.error(response.msg)
      }
    },
    uploadFail () {
      this.loadingInstance.close()
      this.$message.error(this.$t('common.upload_error'))
    },
    removeImage () {
      this.$emit('change', {
        fileId: -1,
        path: '',
        width: 0,
        height: 0
      })
    }
  },
  mixins: [LoadingMixin]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.bg-upload.container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  &.nodashed {
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  .bg-upload {
    position: relative;
    width: 100%;
    height: 100%;
    .icon {
      font-size: 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .m-img-show-outer {
    width: 100%;
    height: 100%;
    background: url("../../assets/images/bg_logo.png");
    .img-show {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
      .operator-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: none;
        .buttons {
          width: 48px;
          height: 24px;
          text-align: center;
          font-size: 0;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          overflow: hidden;
          &.has-no-del {
            width: 24px;
          }
          .btn {
            font-size: 24px;
            cursor: pointer;
            display: block;
            float: left;
            color: rgba(255, 255, 255, 0.8);
          }
          /deep/ .bg-upload-replace {
            width: 24px;
            height: 24px;
            display: block;
            float: left;
          }
        }
      }
      &:hover {
        .operator-wrapper {
          display: block;
        }
      }
    }
  }
}
</style>
